import { useEffect } from 'react';
import { SESSION_DRAG_TYPE } from '@/schedule/scheduleUtils';
import { scheduleDragState, clearDraggingSession } from '@/schedule/scheduleDragState';
import { getSessionDropEffect } from '@/schedule/scheduleModifierKeys';

/**
 * Document-level D&D support: предотвращает "forbidden" курсор и гарантирует
 * очистку состояния при dragend (даже если SessionBubble размонтировался).
 * Решает проблему поломки D&D при стресс-тестах (много копий, optimistic updates).
 */
export function useScheduleDragDropSupport() {
  useEffect(() => {
    clearDraggingSession();

    const handleDragOver = (e: DragEvent) => {
      if (!e.dataTransfer?.types?.includes(SESSION_DRAG_TYPE)) return;
      e.preventDefault();
      const dropEffect = getSessionDropEffect(e, scheduleDragState.isRecorded);
      if (dropEffect) e.dataTransfer.dropEffect = dropEffect;
    };

    const handleDragEnter = (e: DragEvent) => {
      if (!e.dataTransfer?.types?.includes(SESSION_DRAG_TYPE)) return;
      e.preventDefault();
    };

    const handleDragEnd = () => {
      clearDraggingSession();
    };

    document.addEventListener('dragover', handleDragOver, { passive: false });
    document.addEventListener('dragenter', handleDragEnter, { passive: false });
    document.addEventListener('dragend', handleDragEnd);

    return () => {
      document.removeEventListener('dragover', handleDragOver);
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragend', handleDragEnd);
    };
  }, []);
}
